import React, {useState, useEffect, useContext} from 'react';
import {Row, Spinner, Button, Pagination, Modal, Form} from 'react-bootstrap';
import axios from "axios";
import $ from 'jquery';
import { AppContext } from '../../App';
export const All=(props)=>{
	const { link, accessToken, setAccessToken } = useContext(AppContext);
	const [ pageCount, setPageCount ] = useState(0);
	const [ currentPage, setCurrentPage ] = useState(0);
	const [ pageArr, setPageArr ] = useState();
	const [ pageArrIndex, setPageArrIndex ] = useState(0);
	useEffect(()=>{
		if (props.accounts!==undefined) {
			setPageArr(Object.keys(props.accounts));
			let len = Object.keys(props.accounts).length;
			setPageCount(Math.ceil(len/6));
		}
	},[props.accounts]);
	const next=(key)=>{		
		if (pageArrIndex+key<pageCount) {
			setPageArrIndex(prev=>(prev+key));
		}
	}
	const prev=(key)=>{
		if (pageArrIndex-key>=0) {
			setPageArrIndex(prev=>(prev-key));
		}
	}
	const [ currentDetails, setCurrentDetails ] = useState();
	const [ getDetailsLoad, setGetDetailsLoad ] = useState(false);
	const getContactDetails=(id)=>{
		setGetDetailsLoad(true);
    	axios.post(`${link}api/ss/view/account/details/`,{
    			account_id:id.substring(1),
    		},{
            headers:{
            	Authorization: 'Bearer '+accessToken
            }
          }).then((response)=>{
            setGetDetailsLoad(false);
            setCurrentDetails(response.data);
          }).catch((err)=>{
            setGetDetailsLoad(false);
            if(err.response.status === 401){
                setAccessToken();
            }else if(err.response.status === 404){
                console.log('View_account_details_in_all - ',err.response.status,':',err.response.statusText);
            }else if(err.response.status === 500){
                console.log('View_account_details_in_all - ',err.response.status,':',err.response.statusText);
            }else{
                console.log('View_account_details_in_all - ',err.response.status,':',err.response.data);
            }
      	});
	}
	const [ updateAccountLoad, setUpdateAccountLoad ] =  useState(false);
	const [ updateId, setUpdateId ] = useState();
	const [ updateAccountModal, setUpdateAccountModal ] = useState(false);
	useEffect(()=>{
		if (!updateAccountModal) {
			setUpdateId();
		}
	},[updateAccountModal]);
	const [ serverError, setServerError ] = useState(false);
	const updateAccount=(e)=>{
		e.preventDefault();
		setUpdateAccountLoad(true);
    	axios.post(`${link}api/ss/edit/account/`,{
    			account_id:updateId.substring(1),
    			contact_details:e.target.contact.value,
    		},{
            headers:{
            	Authorization: 'Bearer '+accessToken
            }
          }).then((response)=>{
            setUpdateAccountLoad(false);
            if (response.data) {
	            setUpdateAccountModal(false);
	            setUpdateId();				            
                $.alert({
			        title: 'Successful',
			        content: 'Contact details successfully updated!',
			        type: 'green',
			    });
	        }else{
	        	setServerError(true);
	        	setTimeout(()=>{setServerError(false)},5000);
	        }
          }).catch((err)=>{
            setUpdateAccountLoad(false);
            setServerError(true);
            setUpdateId();
	        setTimeout(()=>{setServerError(false)},5000);
            if(err.response.status === 401){
                setAccessToken();
            }else if(err.response.status === 404){
                console.log('Edit_account - ',err.response.status,':',err.response.statusText);
            }else if(err.response.status === 500){
                console.log('Edit_account - ',err.response.status,':',err.response.statusText);
            }else{
                console.log('Edit_account - ',err.response.status,':',err.response.data);
            }
      	});
	}
	const [ resetPasswordLoad, setResetPasswordLoad ] = useState(false);
	const [ resetPassModal, setResetPassModal ] = useState(false);
	useEffect(()=>{
		if (!resetPassModal) {
			setUpdateId();
		}
	},[resetPassModal]);
	const [ reqPass, setReqPass ] = useState(false);
	const [ reqCpass, setReqCpass ] = useState(false);
	const [ passMatchErr, setPassMatchErr ] = useState(false);
	const resetPassword=(e)=>{
		e.preventDefault();
		let pass = e.target.password.value;
		let cpass = e.target.password2.value;
		if (pass==="") {
			setReqPass(true);
			setTimeout(()=>{setReqPass(false)},5000);
		}
		if (cpass==="") {
			setReqCpass(true);
			setTimeout(()=>{setReqCpass(false)},5000);
		}
		if (pass!==""&&cpass!=="") {
			if (pass!==cpass) {
				setPassMatchErr(true);
				setTimeout(()=>{setPassMatchErr(false)},5000);
			}
		}
		if (pass!==""&&cpass!==""&&pass===cpass) {
			setResetPasswordLoad(true);
	    	axios.post(`${link}api/ss/change/account/password/`,{
	    			password:pass,
	    			account_id:updateId.substring(1),
	    		},{
	            headers:{
	            	Authorization: 'Bearer '+accessToken
	            }
	          }).then((response)=>{
	            setResetPasswordLoad(false);
	            if (response.data) {
	            	setUpdateId();				            
	                $.alert({
				        title: 'Successful',
				        content: 'Password successfully updated!',
				        type: 'green',
				    });
		        }else{
		        	setServerError(true);
		        	setTimeout(()=>{setServerError(false)},5000);
		        }
	          }).catch((err)=>{
	            setResetPasswordLoad(false);
	            setServerError(true);
		        setTimeout(()=>{setServerError(false)},5000);
	            if(err.response.status === 401){
	                setAccessToken();
	            }else if(err.response.status === 404){
	                console.log('Change_account_password - ',err.response.status,':',err.response.statusText);
	            }else if(err.response.status === 500){
	                console.log('Change_account_password - ',err.response.status,':',err.response.statusText);
	            }else{
	                console.log('Change_account_password - ',err.response.status,':',err.response.data);
	            }
	      	});
		}

	}
	const [ spageCount, setsPageCount ] = useState(0);
	const [ currentsPage, setCurrentsPage ] = useState(0);
	const [ spageArr, setsPageArr ] = useState();
	const [ spageArrIndex, setsPageArrIndex ] = useState(0);
	useEffect(()=>{
		if (props.search!==undefined) {
			let len = Object.keys(props.search).length;
			setsPageArr(Object.keys(props.search));
			setsPageCount(Math.ceil(len/6));
		}
	},[props.search]);
	const snext=(key)=>{		
		if (spageArrIndex+key<spageCount) {
			setsPageArrIndex(prev=>(prev+key));
		}
	}
	const sprev=(key)=>{
		if (spageArrIndex-key>=0) {
			setsPageArrIndex(prev=>(prev-key));
		}
	}
	return(
		props.accounts!==undefined?(
			Object.keys(props.accounts).length>0?(
				<>
				{
					props.search!==undefined&&Object.keys(props.search).length>0?(
						<Row className="mx-0" >
							{
								Object.keys(props.search).map((renew,r_i)=>(
									spageCount!==undefined&&r_i>=currentsPage&&r_i<currentsPage+6?(
									<div className="bdrb2 all-item py-2 px-3" key={`account_${r_i}`} >
										<div>
											{
												props.search[renew].license_status?(
													<span className="sucess-tag" ><i className="bi bi-check-circle-fill"></i> Active </span>
													):(
													<span className="error-tag" ><i className="bi bi-exclamation-circle-fill"></i> Inactive </span>
													)
											}
											<span className="tp1 f18 px-2" >{props.search[renew].account_name}</span><br />
											<span className="tp2 f14">Expiry Date : {props.search[renew].expiry_date},</span>
											<span onClick={()=>{props.details(renew)}} className="f14 text-primary c-point"> Contact details</span>
											{
								        		props.search[renew].days_remaining<=0?(
								        			<span className="expire-tag mx-2">Expired</span>
								        		):props.search[renew].days_remaining<30?(
								        			<span className="expire-tag mx-2">Expire in {props.search[renew].days_remaining} days.</span>
								        		):''
								        	}
										</div>
										<div className="d-grid" >
											<Button onClick={()=>{
												setResetPassModal(true);
												setUpdateId(renew);
											}} className="btn-t1-r self-center">Reset password</Button>
										</div>
										<div className="d-grid" >
											<Button onClick={()=>{
												setUpdateAccountModal(true);
												setUpdateId(renew);
												getContactDetails(renew);
											}} className="btn-t1-r self-center">Edit contact details</Button>
										</div>
										<div className="d-grid" >
										{
											props.search[renew].license_status?(
												props.disLoad&&props.did!==undefined&&props.did===renew?(
													<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
													props.disAcc(renew,props.search[renew].account_name);
													}} className="btn-disable self-center">Disable</Button>
												)
											):(
												props.enableLoad&&props.enableId!==undefined&&props.enableId===renew?(
													<Button className="btn-enable self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
														props.enable(renew,props.search[renew].account_name)
													}} className="btn-enable self-center">Enable</Button>
												)
											)
										}
										</div>
									</div>
									):''
								))
							}
							<div className='pagination-wrap d-grid mt-3'>
								<Pagination>
							      <Pagination.First onClick={()=>{setsPageArrIndex(0)}} />
							      <Pagination.Prev onClick={()=>{sprev(10)}} />
							      {
								      spageCount!==undefined&&spageArr!==undefined?(
										 spageArr.map((c,ci)=>(
										 	ci<spageCount?(
											 		ci>=spageArrIndex&&ci<spageArrIndex+10?(
												 		currentsPage===ci*6?(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentsPage(ci*6)}} active>{ci+1}</Pagination.Item>
												 		):(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentsPage(ci*6)}} >{ci+1}</Pagination.Item>
												 		)
												 	):''
										 		):''
										 	))
									   ):''
							      }
							      <Pagination.Next onClick={()=>{snext(10)}} />
							      <Pagination.Last onClick={()=>{setsPageArrIndex(Math.ceil(spageCount/10))}}  />
							    </Pagination>
						    </div>
						</Row>
						):(
						<Row className="mx-0" >				
							{
								Object.keys(props.accounts).map((renew,r_i)=>(
									pageCount!==undefined&&r_i>=currentPage&&r_i<currentPage+6?(
										<div className="bdrb2 all-item py-2 px-3" key={`account_${r_i}`} >
											<div>
												{
													props.accounts[renew].license_status?(
														<span className="sucess-tag" ><i className="bi bi-check-circle-fill"></i> Active </span>
														):(
														<span className="error-tag" ><i className="bi bi-exclamation-circle-fill"></i> Inactive </span>
														)
												}
												<span className="tp1 f18 px-2" >{props.accounts[renew].account_name}</span><br />
												<span className="tp2 f14">Expiry Date : {props.accounts[renew].expiry_date},</span>
												<span onClick={()=>{props.details(renew)}} className="f14 text-primary c-point"> Contact details</span>
												{
									        		props.accounts[renew].days_remaining<=0?(
									        			<span className="expire-tag mx-2">Expired</span>
									        		):props.accounts[renew].days_remaining<30?(
									        			<span className="expire-tag mx-2">Expire in {props.accounts[renew].days_remaining} days.</span>
									        		):''
									        	}
											</div>
											<div className="d-grid" >
												<Button onClick={()=>{
													setResetPassModal(true);
													setUpdateId(renew);
												}} className="btn-t1-r self-center">Reset password</Button>
											</div>
											<div className="d-grid" >
												<Button onClick={()=>{
													setUpdateAccountModal(true);
													setUpdateId(renew);
													getContactDetails(renew);
												}} className="btn-t1-r self-center">Edit contact details</Button>
											</div>
											<div className="d-grid" >
											{
												props.accounts[renew].license_status?(
													props.disLoad&&props.did!==undefined&&props.did===renew?(
														<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
													):(
														<Button onClick={()=>{
														props.disAcc(renew,props.accounts[renew].account_name);
														}} className="btn-disable self-center">Disable</Button>
													)
												):(
													props.enableLoad&&props.enableId!==undefined&&props.enableId===renew?(
														<Button className="btn-enable self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
													):(
														<Button onClick={()=>{
															props.enable(renew,props.accounts[renew].account_name)
														}} className="btn-enable self-center">Enable</Button>
													)
												)
											}
											</div>
										</div>
									):''
								))
							}
							<div className='pagination-wrap d-grid mt-3'>
								<Pagination>
							      <Pagination.First onClick={()=>{setPageArrIndex(0)}} />
							      <Pagination.Prev onClick={()=>{prev(10)}} />
							      {
								      pageCount!==undefined&&pageArr!==undefined?(
										 pageArr.map((c,ci)=>(
										 	ci<pageCount?(
											 		ci>=pageArrIndex&&ci<pageArrIndex+10?(
												 		currentPage===ci*6?(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentPage(ci*6)}} active>{ci+1}</Pagination.Item>
												 		):(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentPage(ci*6)}} >{ci+1}</Pagination.Item>
												 		)
												 	):''
										 		):''
										 	))
									   ):''
							      }
							      <Pagination.Next onClick={()=>{next(10)}} />
							      <Pagination.Last onClick={()=>{setPageArrIndex(Math.ceil(pageCount/10))}}  />
							    </Pagination>
						    </div>			    
						</Row>
						)
				}
				<Modal size="lg" show={updateAccountModal} backdrop="static" onHide={()=>{setUpdateAccountModal(false)}}>
			        <Modal.Header closeButton>
			          <Modal.Title>
				          {
				          	serverError!==undefined&&serverError?(
				          		<span className='error-text' >Something went wrong!</span>
				          	):'Update Contact details'
				          }
			          </Modal.Title>
			        </Modal.Header>
			        <Modal.Body>
			        {
			        	getDetailsLoad?(
			        		<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
			        	):(
				        	<Form onSubmit={updateAccount} >
				        		<Form.Group className="mb-3" >
				        			<Form.Label className="tp2">Contact details</Form.Label>
				        			<Form.Control defaultValue={currentDetails!==undefined?currentDetails.contact_details:''} as="textarea" name="contact" className="shadow-none br-2" />
				        		</Form.Group>
				        		<div className="d-grid">
				        		{
				        			updateAccountLoad?(
						    				<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
										):(
				        					<Button type="submit" className="btn-t1">UPDATE</Button>
				        				)			        			
				        		}
				        		</div>
				        	</Form>
			        	)
			        }		        	
				    </Modal.Body>
				    <Modal.Footer></Modal.Footer>
			    </Modal>
			    <Modal size="lg" show={resetPassModal} backdrop="static" onHide={()=>{setResetPassModal(false)}}>
			        <Modal.Header closeButton>
			          <Modal.Title>
				          {
				          	serverError!==undefined&&serverError?(
				          		<span className='error-text' >Something went wrong!</span>
				          	):'Reset password'
				          }
			          </Modal.Title>
			        </Modal.Header>
			        <Modal.Body>
			        {
			        	getDetailsLoad?(
			        		<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
			        	):(
				        	<Form onSubmit={resetPassword} >
				        		<Form.Group className="mb-3" >
			        			<Form.Label  className="tp2">Password 
				        			{reqPass?(<span className="error-message" >This field is required</span>):''}
				        			{passMatchErr?(<span className="error-message" >Password and Confirm password do not match!</span>):''}
				        			</Form.Label>
				        			<Form.Control type="password" name="password" className="shadow-none br-2" placeholder="Password" />
				        		</Form.Group>
				        		<Form.Group className="mb-3" >
				        			<Form.Label className="tp2">Confirm Password {reqCpass?(<span className="error-message" >This field is required</span>):''}</Form.Label>
				        			<Form.Control type="password" name="password2" className="shadow-none br-2" placeholder="Confirm password" />
				        		</Form.Group>
				        		<div className="d-grid">
				        		{
				        			resetPasswordLoad?(
						    				<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
										):(
				        					<Button type="submit" className="btn-t1">RESET</Button>
				        				)			        			
				        		}
				        		</div>
				        	</Form>
			        	)
			        }		        	
				    </Modal.Body>
				    <Modal.Footer></Modal.Footer>
			    </Modal>
				</>
				):(<span className="tp3 p-3" >Nothing to renew.</span>)
			):(<span className="tp3 p-3" >Fetching data...</span>)
		)
}